<template>
  <div
    :class="['radio', checked ? 'checked' : 'no-checked', disabled && 'disable-checked']" @click='changeRadio'
  >
  </div>
</template>

<script>
  export default {
    name: 'radio1',
    props: {
      message: String,
      checked: {
        type: Boolean,
        default: () => false
      },
      disabled: {
        type: Boolean
      }
    },
    data () {
      return {
      }
    },
    watch: {},
    computed: {},
    created () {
    },
    mounted () {
    },
    methods: {
      changeRadio(){
        if(this.disabled == true){
          return false;
        }else{
          this.$emit('changeRadio')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .radio{
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    // border:1px solid #7ADFDF;
    // border-radius:16px; 
    &.checked{
      background: url("/images/public/icon-checked-theme.png") no-repeat center;
      background-size: 95%;
    }
    &.no-checked{
      background: url("/images/public/icon-nochecked-theme.png") no-repeat center;
      background-size:95%;
    }
    &.disable-checked{
      background: url("/images/public/disable-checked.png") no-repeat center;
      background-size: 95%;
    }
  }
</style>
